export const COMPLETE = 'complete';
export const PENDING = 'pending';
export const FAIL = 'fail';
export const CODE_RESENT = 'code_resent';
export const ERROR = 'error';
export const BASE = 'base';
